import type { StateCreator } from 'zustand';
import type { BookingSuccessResponse, CabUpdateResponse } from '@/api';

/**
 * Trip booking state interface
 * Manages booking data and real-time cab updates
 */
export interface TripBookingState {
	/** Main booking data from initial API call */
	bookingData: BookingSuccessResponse['data'] | null;
	/** Real-time cab updates from polling */
	cabUpdate: CabUpdateResponse | null;
}

/**
 * Trip booking actions interface
 */
export interface TripBookingActions {
	/** Set initial booking data from API response */
	setBookingData: (data: BookingSuccessResponse['data']) => void;
	/** Update cab information from polling */
	updateCabData: (cabUpdate: CabUpdateResponse) => void;
}

/**
 * Combined trip booking slice interface
 */
export interface TripBookingSlice {
	tripBooking: TripBookingState;
	tripBookingActions: TripBookingActions;
}

/**
 * Initial state for trip booking
 */
const initialState: TripBookingState = {
	bookingData: null,
	cabUpdate: null,
};

export const createTripBookingSlice: StateCreator<
	TripBookingSlice,
	[],
	[],
	TripBookingSlice
> = (set, _get, _api) => ({
	tripBooking: initialState,

	tripBookingActions: {
		// Set initial booking data from API response
		setBookingData: (data: BookingSuccessResponse['data']) => {
			set((state) => ({
				tripBooking: {
					...state.tripBooking,
					bookingData: data,
				},
			}));
		},

		// Update cab information from real-time polling
		updateCabData: (cabUpdate: CabUpdateResponse) => {
			set((state) => ({
				tripBooking: {
					...state.tripBooking,
					cabUpdate,
				},
			}));
		},
	},
});
